import { toResponseKey } from '@/common/api/keyCasing';
import type { TelemetryResolution } from '@/features/telemetry/services/schemas';

/**
 * Key under which a numeric metric's value lands on a series point.
 *
 * At 1-minute resolution the wire key is the bare variable name; at 15-minute
 * resolution it's the `_avg` aggregate. Either way, the value is exactly what
 * ApiClient's response interceptor renames it to (see telemetryKeys.test.ts and
 * common/api/keyCasing.ts) — never a hand-rolled camelize.
 */
export const numericMetricKey = (variable: string, resolution: TelemetryResolution): string =>
  toResponseKey(resolution === '1min' ? variable : `${variable}_avg`);

/** Key under which an enum/state metric's bucket value lands on a series point. */
export const enumMetricKey = (variable: string, resolution: TelemetryResolution): string =>
  toResponseKey(resolution === '1min' ? variable : `${variable}_last`);
